import { injectable } from "inversify"

import * as Api from "../constants/ApiUrlConstants"
import container from "../wires/Bootstrapper"
import SERVICE_IDENTIFIER from "../wires/Identifiers"

import { IApiService } from "./shared/ApiService"
import { IApiServiceExt } from "./shared/ApiServiceExt";

import { ModelBase } from "../models/ModelBase"
import { ImportYapilyMovimentiModel, MovimentoEditModel, RaccoltaDatiInputModel, RaccoltaDatiModel, Saldo } from "../models/RaccoltaDatiModels"
import moment from "moment"

export interface IRaccoltaDatiService {
    Get(periodo: Date, clienteId?: string): Promise<RaccoltaDatiModel>
    Save(data: RaccoltaDatiInputModel): Promise<ModelBase>
    GetMovimento(id: string): Promise<MovimentoEditModel>
    SaveMovimento(data: MovimentoEditModel): Promise<ModelBase>
    DeleteMovimento(id: string): Promise<ModelBase>
    SaveSaldo(data: Saldo): Promise<ModelBase>
    ImportMovimenti(contoCorrenteId: string, periodo: string, file: File): Promise<ModelBase>
    DownloadMovimenti(model: ImportYapilyMovimentiModel): Promise<ModelBase>
    DownloadSaldo(): Promise<ModelBase>
}

@injectable()
export class RaccoltaDatiService implements IRaccoltaDatiService {

    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE)
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
    }

    async Get(periodo: Date, clienteId?: string): Promise<RaccoltaDatiModel> {
        return this.apiService.getAsync(Api.RaccoltaDatiGet, { Periodo: moment(periodo).format("YYYY/MM/DD"), ClienteId: clienteId })
    }

    async Save(data: RaccoltaDatiInputModel): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.RaccoltaDatiSave, data)
    }

    async GetMovimento(id: string): Promise<MovimentoEditModel> {
        return this.apiService.getAsync(Api.RaccoltaDatiGetMovimento, { Id: id })
    }

    async SaveMovimento(data: MovimentoEditModel): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.RaccoltaDatiSaveMovimento, data)
    }

    async DeleteMovimento(id: string): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.RaccoltaDatiDeleteMovimento, { Id: id })
    }

    async SaveSaldo(data: Saldo): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.RaccoltaDatiSaveSaldo, data)
    }

    async ImportMovimenti(contoCorrenteId: string, periodo: string, file: File): Promise<ModelBase> {
        let formData = new FormData()
        formData.append("ContoCorrenteId", contoCorrenteId)
        formData.append("Periodo", periodo)
        formData.append("File", file)

        return this.apiServiceExt.postAsync(Api.RaccoltaDatiImportMovimenti, formData)
    }

    async DownloadMovimenti(model: ImportYapilyMovimentiModel): Promise<ModelBase> {
        return this.apiServiceExt.postAsync(Api.RaccoltaDatiDownloadMovimenti, model)
    }

    async DownloadSaldo(): Promise<ModelBase> {
        return this.apiServiceExt.getAsync(Api.RaccoltaDatiDownloadSaldo, "")
    }
}